export enum Translations {
  ASCENDING = "Възходящ ред",
  DESCENDING = "Низходящ ред",
  CLEAR = "Премахни",
  CLEAR_ALL = "Изчисти всички филтри",
  UNSORT = "Без сортиране",
  GROUP = "Групирай",
  UNGROUP = "Разгрупирай",
  LOCK_START = "Заключи в началото",
  LOCK_END = "Заключи в края",
  UNLOCK = "Отключи",
  COLUMNS = "Колони",
  AUTOSIZE_TO_FIT = "Автоматично нагласяне",
  AUTORESIZE_THIS_COLUMN = "Автоматично нагласяне на тази колона",
  AUTORESIZE_ALL_COLUMNS = "Автоматично нагласяне на всички колони",
  SHOW_FILTERING_ROW = "Покажи филтриращия ред",
  HIDE_FILTERING_ROW = "Скрий филтриращия ред",
  CONTAINS = "Съдържа",
  DOES_NOT_CONTAIN = "Не съдържа",
  EQUALS = "Равно на",
  DOES_NOT_EQUAL = "Не е равно на",
  EMPTY = "Празно",
  NOT_EMPTY = "Не е празно",
  STARTS_WITH = "Започва с",
  ENDS_WITH = "Завършва с",
  ENABLE = "Разреши",
  DISABLE = "Забрани",
  OF_TEXT = "от",
  PAGE = "Страница",
  PER_PAGE = "Резултати на страница",
  SHOWING_TEXT = "Показване на ",
  LOADING = "Зареждане на данни",
  NO_DATA = "Няма намерени данни",
}
